import React, { useEffect, useState } from "react";
import { getEnvironmentProps } from "../../../../../utils/environment";
import { parseToken } from "../../../../../utils/helpers";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import { dmnStorage } from "../../../../../utils/dmnStorage";

export function DebugContent() {
  const [storageItems, setStorageItems] = useState<any>({});
  const [otherItems, setOtherItems] = useState<any>({});

  useEffect(() => {
    (async () => {
      setStorageItems({
        venueId: await dmnStorage.get("venueId"),
        SubscriptionId: await dmnStorage.get("SubscriptionId"),
        user: (await dmnStorage.get("user"))?._id || "No user id",
        gridConfig: JSON.stringify(await dmnStorage.get("gridConfig")),
        featureFlags: JSON.stringify(await dmnStorage.get("featureFlags"))
      });

      const token = await dmnIdentity.getAccessToken();
      const tokenParts = parseToken(token);

      setOtherItems({
        token: JSON.stringify(tokenParts),
        envVars: JSON.stringify(getEnvironmentProps(token))
      });
    })();
  }, []);

  return (
    <div className="DebugContent flex flex-col justify-center items-center h-full overflow-scroll text-center [&>*]:my-[10px]">
      <h2>Logs</h2>
      <div>
        <button
          onClick={() => {
            document
              .getElementById("ConsoleLogs")
              ?.classList.add("ConsoleLogVisible");
          }}
        >
          Show Logs
        </button>
      </div>
      <h2>Storage</h2>
      <p>venueId {storageItems.venueId}</p>
      <p>SubscriptionId {storageItems.SubscriptionId}</p>
      <p>DMN User {storageItems.user}</p>
      <p>gridConfig {storageItems.gridConfig}</p>
      <p>featureFlags {storageItems.featureFlags}</p>
      <h2>Environment</h2>
      <p>token {otherItems.token}</p>
      <p>envVars {otherItems.envVars}</p>
    </div>
  );
}
